/**
 * readArStoredFormulaResult
 *
 * The read side of arFormulaTargetFieldSegments: returns the persisted formula
 * result at a target's storage location, or undefined when none was ever
 * written. Deliberately narrower than readArCellOperand — no `value` fallback
 * for plain targets and no coercion of absence to 0, because "no stored
 * result" must stay distinguishable from a stored 0 for the reconcile guard
 * and the consistency alarms (arFormulaValuesMatch treats null-computed as
 * matching only absence). Consumers: reconcileArRow's write guard and every
 * step-4 reader that verifies the stored value against its own computation.
 */

import type { ArCell, TypeId } from '../System.Artifacts.types';

function readArStoredFormulaResult(
  cells: Partial<Record<TypeId, ArCell>> | undefined,
  typeId: string,
): unknown {
  const dotIndex = typeId.indexOf('.');
  if (dotIndex === -1) {
    return cells?.[typeId as TypeId]?.calcInput;
  }
  const col = typeId.slice(0, dotIndex) as TypeId;
  const sub = typeId.slice(dotIndex + 1);
  const compositeValue = cells?.[col]?.value as
    | { fields?: Record<string, { value?: unknown }> }
    | undefined;
  return compositeValue?.fields?.[sub]?.value;
}

export { readArStoredFormulaResult };
